import { render, staticRenderFns } from "./RoleManagerPage.vue?vue&type=template&id=74425b4c&scoped=true&"
import script from "./RoleManagerPage.vue?vue&type=script&lang=js&"
export * from "./RoleManagerPage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagerPage.vue?vue&type=style&index=0&id=74425b4c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74425b4c",
  null
  
)

export default component.exports